import React from "react";
import { Tooltip } from "@/components/common/Tooltip";
import { TabDefinition } from "./TabMenu";

export interface TabHeaderProps {
  tabs: TabDefinition[];
  activeTabId: string;
  onTabChange: (tabId: string) => void;
  actions?: React.ReactNode[];
  middleContent?: React.ReactNode;
  tabsContainerClassName?: string;
}

export const TabHeader: React.FC<TabHeaderProps> = ({
  tabs,
  activeTabId,
  onTabChange,
  actions = [],
  middleContent,
  tabsContainerClassName = "flex flex-none flex-row space-x-2 items-center justify-start select-none",
}) => {
  return (
    <div className="flex flex-row items-center w-full">
      <div className={tabsContainerClassName}>
        {tabs.map((tab) => {
          const isActive = tab.id === activeTabId;

          const button = (
            <button
              key={tab.id}
              onClick={() => !tab.disabled && onTabChange(tab.id)}
              disabled={tab.disabled}
              className={[
                "tab-option",
                tab.disabled
                  ? "tab-option-inactive opacity-50"
                  : "cursor-pointer",
                !tab.disabled && isActive
                  ? "tab-option-active"
                  : !tab.disabled
                    ? "tab-option-inactive"
                    : "",
              ]
                .filter(Boolean)
                .join(" ")}
              aria-label={`${tab.label} tab`}
              aria-pressed={!tab.disabled && isActive}
            >
              {tab.label && <span>{tab.label}</span>}
              {tab.icon && tab.icon}
            </button>
          );

          if (tab.disabled && tab.tooltip) {
            return (
              <Tooltip key={tab.id} title={tab.tooltip}>
                <span>{button}</span>
              </Tooltip>
            );
          }

          return button;
        })}
      </div>
      {middleContent && (
        <div className="flex flex-none items-center ml-2">{middleContent}</div>
      )}
      {actions.length > 0 && (
        <div className="flex flex-none items-center gap-2 ml-auto">
          {actions.map((action, index) => (
            <div key={index}>{action}</div>
          ))}
        </div>
      )}
    </div>
  );
};
